import React from 'react';
import styled from '@emotion/styled';
import { EmotionBreakpoint } from 'dw-au-react-components';
import { RichTextRenderer } from '../../RichTextRenderer';

const StyledMainTitle = styled.div`
	h2 {
		font-size: ${(props) => (props.titleFontSize || '40') + 'px'};
		line-height: ${(props) => (props.titleLineHeight || '48') + 'px'};
		color: ${(props) => props.titleColor || '#212121'};

		${EmotionBreakpoint('mobile')} {
			font-size: 24px;
			line-height: 30px;
		}
	}
`;

const StyledMainTitleBackground = styled.div`
	background-color: ${(props) => props.backgroundColor || '#ffffff'};
	padding: 40px 0 25px;
`;

function MainTitle({
	props: {
		title,
		titleColor,
		titleAlignment,
		titleFontSize,
		titleLineHeight,
		content,
		contentAlignment,
		contentColor,
		backgroundColor,
		fullScreenBackground,
	},
}) {
	let output = (
		<div className='container'>
			<StyledMainTitle
				titleColor={titleColor}
				titleFontSize={titleFontSize}
				titleLineHeight={titleLineHeight}
			>
				{title && (
					<h2 className={'mb-20 lower text-' + titleAlignment}>{title}</h2>
				)}

				{content?.content && content?.content.length > 0 && (
					<div className={'text-' + contentAlignment}>
						<RichTextRenderer
							content={content}
							color={contentColor}
							imageTitle={title}
						/>
					</div>
				)}
			</StyledMainTitle>
		</div>
	);

	if (fullScreenBackground) {
		output = (
			<StyledMainTitleBackground backgroundColor={backgroundColor}>
				{output}
			</StyledMainTitleBackground>
		);
	}
	return output;
}

export default MainTitle;
